import ArgosJobModel from '@modules/events/forms/ArgosJob/ArgosJobModel';

export default function ArgosJobEditModel() {
    let argosJobEditModel = ArgosJobModel();

    argosJobEditModel.title = (data) => {
        let title = 'Argos job';

        if (data?.argosJob?.id) {
            title = `Argos job ${data.argosJob.id}`;
        }

        return title;
    };

    argosJobEditModel.fields.output_tunnel_group.forEach(group => {
        if (group.third_party_client_tunnel) {
            group.third_party_client_tunnel.props.hidden = false;
        }
    });

    return argosJobEditModel;
}
